export var WidthVariants;
(function (WidthVariants) {
    WidthVariants["large"] = "large";
    WidthVariants["medium"] = "medium";
    WidthVariants["small"] = "small";
})(WidthVariants || (WidthVariants = {}));
//# sourceMappingURL=types.js.map